import React from 'react'
import { Updater, Widget, any, async, fromJSX, stateful } from 'widgets-for-react'
import { DossierBlock } from '../../blocksState'
import { DossierHighlightBlockLayout } from './dossierHighlightBlock.layout'
import { DossierBlockState, dossierBlockStateUpdaters, initialDossierBlockState } from './dossierHighlightBlock.state'
import { DossierHighlightResult } from '../../../../../backendApi/generated'

export const DossierHightlightBlockWidget = (block: DossierBlock): Widget<Updater<DossierBlockState>> => {
  var w = fromJSX<Updater<DossierBlockState>>((setState) =>
    stateful()((s0: DossierBlockState) =>
      any<Updater<DossierBlockState>>([
        async<DossierHighlightResult>(s0.highlight, (highlight) => fromJSX(() => {
          return <DossierHighlightBlockLayout
            index={0}
            highlight={{
              title: block.title,
              intro: block.intro,
              // Prefer the current path; the stored slug goes stale when the dossier page is renamed
              url: highlight?.DossierPath ?? (block.dossierSlug ? `/dossiers/${block.dossierSlug}` : '#'),
              image: block.image
            }}
            items={highlight?.NewsPages ?? []} />
        })).map(dossierBlockStateUpdaters.updateHighlight),
      ])
    )(initialDossierBlockState(block.dossierPageId, block.dossierName)).run(s => s))
  return w;
}
